import $http from '@/http'

const comHttp = (url, method, data, callback, back, error, loginBack, isFormData) => {
  $http[method](url, data, isFormData).then((res) => {
    if (method === 'downLoad') {
      if (!res.data.code) { // 如果返回有code说明错误了
        let rHeader = res.headers['content-disposition']
        let fileName = decodeURI(rHeader ? rHeader.split('=')[1] : '')
        let blob = new Blob([res.data], {type: 'application/vnd.ms-excel'})
        let eLink = document.createElement('a')
        eLink.href = URL.createObjectURL(blob)
        eLink.download = fileName
        document.body.appendChild(eLink)
        eLink.click()
        document.body.removeChild(eLink)
      }
      if (callback) {
        callback()
      }
    } else {
      if (res.status === 502) {
        setTimeout(() => {
          comHttp(url, method, data, callback, back, error)
        }, 1000)
      } else {
        if (res.data.code === 200) {
          callback(res.data.data)
        } else if (res.data.code === 2004) {
          if (loginBack) {
            loginBack(res.data.data)
          }
        } else {
          if (error) {
            error(res.data.data)
          }
        }
        if (back) {
          back()
        }
      }
    }
  }).catch(() => {
    if (back) {
      back()
    }
  })
}

// 生成验证码
const captcha = (callback, back) => {
  comHttp('/api/archives/user/captcha', 'get', '', callback, back)
  // comHttp('/api/auth/captcha', 'get', '', callback, back)
}

// 获取验证码
const getCode = (data, callback, back) => {
  comHttp('/api/auth/send_sms', 'get', data, callback, back)
}

// 登入
const login = (data, callback, back, error) => {
  comHttp('/api/archives/user/login', 'post', data, callback, back, error)
  // comHttp('/api/auth/login', 'post', data, callback, back, error)
}

// 退出
const logout = (callback, back) => {
  comHttp('/api/archives/user/logout', 'post', '', callback, back)
}

// 修改密码
const passwordUpdate = (data, callback, back) => {
  comHttp('/api/archives/user/updatePassword', 'put', data, callback, back)
}

// 获取用户信息
const loginInfo = (callback, back) => {
  // comHttp('/api/login_info', 'get', '', callback, back)
  comHttp('/api/archives/user/loginInfo', 'get', '', callback, back)
}

// 获取学校字典
const getSchool = (callback, back) => {
  comHttp('/api/archives/university/selectList', 'get', '', callback, back)
}

// 获取省市
const getProvince = (callback, back) => {
  comHttp('/api/archives/common/province', 'get', '', callback, back)
}

// 获取申请列表
const getApplyList = (data, callback, back) => {
  comHttp('/api/archives/student/selectPage', 'get', data, callback, back)
}

// 删除申请
const delApply = (ids, callback, back) => {
  comHttp('/api/archives/student/' + ids, 'del', '', callback, back)
}

// 获取参数
const getParam = (callback, back) => {
  comHttp('/api/archives/common/config', 'get', '', callback, back)
}

// 修改参数
const updateParam = (data, callback, back) => {
  comHttp('/api/archives/config', 'put', data, callback, back)
}

// 获取用户
const getUser = (data, callback, back) => {
  comHttp('/api/archives/user/userInfo', 'get', data, callback, back)
}
// 删除用户
const delUser = (ids, callback, back) => {
  comHttp('/api/archives/user/' + ids, 'del', '', callback, back)
}

// 新增用户
const addUser = (data, callback, back) => {
  comHttp('/api/archives/user/add', 'post', data, callback, back)
}

// 获取学校分页列表
const getSchoolList = (data, callback, back) => {
  comHttp('/api/archives/university/selectPage', 'get', data, callback, back)
}

// 删除学校
const delSchool = (ids, callback, back) => {
  comHttp('/api/archives/university/' + ids, 'del', '', callback, back)
}

// 新增学校
const addSchool = (data, callback, back) => {
  comHttp('/api/archives/university/addUniversity', 'post', data, callback, back)
}

// 修改学校
const editSchool = (id, data, callback, back) => {
  comHttp('/api/archives/university/' + id, 'put', data, callback, back)
}

// 导出excel
const exportExcel = (data, callback, back) => {
  loginInfo(() => {
    comHttp('/api/archives/excel/export', 'downLoad', data, callback, back)
  })
}

// 导出excel模版
const exportExcelTemplate = (callback, back) => {
  loginInfo(() => {
    comHttp('/api/archives/excel/template/university', 'downLoad', '', callback, back)
  })
}

// 获取往届详情
const getDesc = (id, callback, back) => {
  comHttp('/api/archives/student/findStudentForId', 'get', {id: id}, callback, back)
}

// 修改申请
const editApply = (id, data, callback, back) => {
  comHttp('/api/archives/student/' + id, 'post', data, callback, back)
}

// 获取上传信息
const getUploadInfo = (callback, back) => {
  comHttp('/api/archives/common/temp_obs_key', 'get', '', callback, back)
  // comHttp('/api/archives/common/temp_cos_key', 'get', '', callback, back)
}

// 同步
const updateNotice = (callback, error) => {
  comHttp('/api/archives/notice/updateData', 'post', '', callback, '', error)
}

// 导出excel模版-学生
const exportStudentTemplate = (callback, back) => {
  comHttp('/api/archives/excel/template/student', 'downLoad', '', callback, back)
}

// 同步开启
const toggleSync = (id, callback, error) => {
  comHttp('/api/archives/student/' + id + '/toggle_sync', 'post', '', callback, '', error)
}

// 通知列表
const getNoticeList = (data, callback, back) => {
  comHttp('/api/archives/notice/select_page', 'get', data, callback, back)
}

// 通知添加
const addNotice = (data, callback, back) => {
  comHttp('/api/archives/add_notice', 'post', data, callback, back)
}

// 通知添加
const editNotice = (id, data, callback, back) => {
  comHttp('/api/archives/edit_notice/' + id, 'post', data, callback, back)
}

// 通知详情
const descNotice = (id, callback, back) => {
  comHttp('/api/archives/notice/' + id, 'get', '', callback, back)
}

// 通知删除
const delNotice = (id, callback, back) => {
  comHttp('/api/archives/delete_notice/' + id, 'del', '', callback, back)
}

// 切换
const toggleNotice = (id, callback, back) => {
  comHttp('/api/archives/toggle_notice/' + id, 'put', '', callback, back)
}

// 切换应往届
const toggleSchoolStatus = (id, key, callback, back) => {
  comHttp('/api/archives/university/' + id + '/toggle_' + key, 'put', '', callback, back)
}

// 批量修改省市
const editSchoolPid = (ids, pid, callback, back) => {
  comHttp('/api/archives/university/' + ids + '/' + pid, 'put', '', callback, back)
}

// 获取学校信息
const getSchoolDesc = (id, callback) => {
  comHttp('/api/archives/university/' + id + '/info', 'get', '', callback)
}

export default {
  getSchoolDesc,
  editSchoolPid,
  toggleSchoolStatus,
  toggleNotice,
  delNotice,
  descNotice,
  editNotice,
  addNotice,
  getNoticeList,
  captcha,
  login,
  getCode,
  logout,
  passwordUpdate,
  loginInfo,
  getSchool,
  getProvince,
  getSchoolList,
  getApplyList,
  delApply,
  editApply,
  getParam,
  updateParam,
  getUser,
  delUser,
  addUser,
  delSchool,
  addSchool,
  editSchool,
  exportExcel,
  exportExcelTemplate,
  getDesc,
  getUploadInfo,
  updateNotice,
  exportStudentTemplate,
  toggleSync
}



// WEBPACK FOOTER //
// ./src/assets/js/ajax.js